"use client";

import LoginPageShell from "@/components/auth/login/login-page-shell";

export default function LoginPage() {
  return <LoginPageShell />;
}
